import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const TRANSITION = '400ms ease-in-out';

export const expandableContentWrapper = css`
  box-sizing: content-box !important;
  padding-bottom: ${pxToRem(26)} !important;
  overflow: hidden;
  transition: height ${TRANSITION};
  position: relative;
  word-break: break-word;

  &:after {
    content: '';

    pointer-events: none;
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    height: ${pxToRem(70)};
    width: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255) 30%,
      rgba(255, 255, 255) 100%
    );
    transition: height ${TRANSITION};
  }

  &[data-is-expanded='true'] {
    &:after {
      height: 0;
    }
  }
`;

export const expandingSection = css`
  position: relative;
`;

export const expandableToggleButton = css`
  max-width: ${pxToRem(181)};
  max-height: ${pxToRem(36)};
`;
